import type { TypographyProps } from '@mui/material';
import { Box, Skeleton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { ColumnItem } from '../ColumnItem/ColumnItem';
import { DraggableList } from '../DraggableList/DraggableList';

const Header = styled((props: TypographyProps) => {
  return <Typography {...props} />;
})(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  paddingBottom: theme.spacing(1),
  fontWeight: 600,
  fontSize: '0.875rem',
  lineHeight: '1rem',
  letterSpacing: 0,
  color: '#7E828F',
  backgroundColor: 'white',
  position: 'sticky',
  top: 0,
  zIndex: 1,
}));

export interface ColumnInfo {
  id: string;
  name: string;
  description: string;
}

interface Props {
  loaded: boolean;
  title: string;
  columns: ColumnInfo[];
  onDelete: (id: string) => void;
  onChange: (columns: ColumnInfo[]) => void;
}

export function ColumnsGroupList({
  loaded,
  title,
  columns,
  onDelete,
  onChange,
}: Props) {
  if (!loaded) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Header>{title}</Header>
        <Skeleton
          sx={{ borderRadius: 2, height: 50, ml: 3 }}
          variant="rectangular"
        />
      </Box>
    );
  }

  return (
    <DndProvider backend={HTML5Backend}>
      <Header>{title}</Header>
      {columns.length === 0 && (
        <Typography sx={{ ml: 3 }} color="secondary" variant="caption">
          Nothing selected
        </Typography>
      )}
      <DraggableList
        sx={{ pl: 3, mb: 1 }}
        items={columns}
        renderItem={(item) => {
          return <ColumnItem {...item} onDelete={onDelete} />;
        }}
        onChange={onChange}
      />
    </DndProvider>
  );
}
